import { apiRequest } from "../lib/apiClient";
import type { ReturnCreate, ReturnOut } from "./types";

/** `GET /returns` — any authenticated user. */
export async function listReturns(accessToken: string, saleId?: string): Promise<ReturnOut[]> {
  return apiRequest<ReturnOut[]>("/returns", { accessToken, query: { sale_id: saleId } });
}

export async function getReturn(accessToken: string, returnId: string): Promise<ReturnOut> {
  return apiRequest<ReturnOut>(`/returns/${returnId}`, { accessToken });
}

/** `POST /returns` — OWNER/BRANCH_MANAGER only (backend: "a TELLER accidentally being
 * able to refund arbitrary amounts is a real risk"). */
export async function createReturn(accessToken: string, body: ReturnCreate): Promise<ReturnOut> {
  return apiRequest<ReturnOut>("/returns", { method: "POST", accessToken, body });
}
